export default __webpack_public_path__ + "static/media/locationOn.31e27793.svg";